module.exports = __webpack_public_path__ + "img/playing-video-games-online.8abf1b2c.svg";